// Közös „személy-chip" atom: avatar (presigned kép → monogram-fallback) + locale-tudatos név. A név a
// `formatName`-mel formázódik (HU: vezetéknév elöl; más locale: keresztnév elöl), a strukturált részek
// hiányában a `name` (displayName/e-mail) a fallback. A név-szöveg SZÁNDÉKOSAN a KÖRNYEZŐ tipográfiát
// ÖRÖKLI (nem kényszerít méretet/színt) → egy lista-cellában a DataTable cella-stílusát kapja (13/muted),
// máshol az ottani szöveget. Cross-feature (fiók-lista admin/kapcsolattartó, később bárhol ahol személy
// jelenik meg egy sorban) → components/shared/.
import { useTranslation } from 'react-i18next';

import { Avatar } from '@/components/ui/avatar';
import { formatName } from '@/lib/format-name';
import { cn } from '@/lib/utils';

export interface PersonChipProps {
  /** Keresztnév (strukturált) — a locale-tudatos névsorrendhez. */
  givenName?: string | null;
  /** Vezetéknév (strukturált) — a locale-tudatos névsorrendhez. */
  familyName?: string | null;
  /** Fallback megjelenítendő név (displayName/e-mail), ha a strukturált részek hiányoznak. */
  name?: string | null;
  /** Presigned profilkép-URL; hiányzik/hibás → monogram-fallback. */
  avatarUrl?: string | null;
  /** Részleg szín-token (MORGENS-paletta) — az avatar-háttere (belső kolléga); a globális Avatar `accentColor`-ja. */
  accentColor?: string | null;
  /** Avatar-méret: `sm` (22px, lista-sor) / `md` (28px). Alap: `md`. */
  size?: 'sm' | 'md';
  className?: string;
}

/** Avatar + locale-tudatos név egy sorban. A név a környező tipográfiát örökli (lista-cellában 13/muted). */
export function PersonChip({
  givenName,
  familyName,
  name,
  avatarUrl,
  accentColor,
  size = 'md',
  className,
}: PersonChipProps): JSX.Element {
  const { i18n } = useTranslation();
  const label = formatName({ givenName, familyName, displayName: name }, i18n.language);
  return (
    <span className={cn('flex min-w-0 items-center gap-2', className)}>
      <Avatar name={label} src={avatarUrl ?? null} size={size} accentColor={accentColor} />
      <span className="min-w-0 truncate">{label}</span>
    </span>
  );
}
